<template>
    <div>
		<ul class="nav nav-tabs details-tabs" role="tablist">
		    <li role="presentation" class="active">
		        <a href="#overview" aria-controls="home" role="tab" data-toggle="tab">产品概览</a>
		    </li>
		    <li role="presentation">
		        <a href="#details" aria-controls="profile" role="tab" data-toggle="tab">款式</a>
		    </li>
		</ul>
		<div class="tab-content">
		    <div role="tabpanel" class="tab-pane active" id="overview">
				<img src="../assets/img/detail/zsw/1.jpg" width="100%" />
				<img src="../assets/img/detail/zsw/2.jpg" width="100%"/>
				<img src="../assets/img/detail/zsw/3.jpg" width="100%"/>
				<img src="../assets/img/detail/zsw/4.jpg" width="100%"/>
				<img src="../assets/img/detail/zsw/5.jpg" width="100%"/>
				<img src="../assets/img/detail/zsw/6.jpg" width="100%"/>
				<img src="../assets/img/detail/zsw/7.jpg" width="100%"/>
				<img src="../assets/img/detail/zsw/8.jpg" width="100%"/>
				<img src="../assets/img/detail/zsw/9.jpg" width="100%"/>
				<img src="../assets/img/detail/zsw/10.jpg" width="100%"/>
				<img src="../assets/img/detail/zsw/11.jpg" width="100%"/>
		    </div>
		    <div role="tabpanel" class="tab-pane ampic-list" id="details">
		    		<div class="row">
		    			<div class="col-md-4">
		    				<div class="pic-box">
		    					<img src="../assets/img/am01.jpg"/>
		    				</div>
		    				<h4>AM-O-0260A</h4>
		    			</div>
		    			<div class="col-md-4">
		    				<div class="pic-box">
		    					<img src="../assets/img/am02.jpg"/>
		    				</div>
		    				<h4>AM-O-0260B</h4>
		    			</div>
		    			<div class="col-md-4">
		    				<div class="pic-box">
		    					<img src="../assets/img/am03.jpg"/>
		    				</div>
		    				<h4>AM-C-0682</h4>
		    			</div>
		    			<div class="col-md-4">
		    				<div class="pic-box">
		    					<img src="../assets/img/am04.jpg"/>
		    				</div>
		    				<h4>AM-C-0690</h4>
		    			</div>
		    			<div class="col-md-4">
		    				<div class="pic-box">
		    					<img src="../assets/img/am05.jpg"/>
		    				</div>
		    				<h4>AM-C-3602</h4>
		    			</div>
		    			<div class="col-md-4">
		    				<div class="pic-box">
		    					<img src="../assets/img/am06.jpg"/>
		    				</div>
		    				<h4>AM-P-1883</h4>
		    			</div>
		    			
		    			<div class="col-md-4">
		    				<div class="pic-box">
		    					<img src="../assets/img/am07.jpg"/>
		    				</div>
		    				<h4>AM-Y-3132</h4>
		    			</div>
		    			<div class="col-md-4">
		    				<div class="pic-box">
		    					<img src="../assets/img/am08.jpg"/>
		    				</div>
		    				<h4>AM-T-0057</h4>
		    			</div>
		    			<div class="col-md-4">
		    				<div class="pic-box">
		    					<img src="../assets/img/am09.jpg"/>
		    				</div>
		    				<h4>AM-R-1941</h4>
		    			</div>
		    			<div class="col-md-4">
		    				<div class="pic-box">
		    					<img src="../assets/img/am10.jpg"/>
		    				</div>
		    				<h4>AM-R-1955</h4>
		    			</div>
		    			<div class="col-md-4">
		    				<div class="pic-box">
		    					<img src="../assets/img/am11.jpg"/>
		    				</div>
		    				<h4>AM-R-1967</h4>
		    			</div>
		    			<div class="col-md-4">
		    				<div class="pic-box">
		    					<img src="../assets/img/am12.jpg"/>
		    				</div>
		    				<h4>AM-R-1981</h4>
		    			</div>
		    		</div>	
		    </div>
		</div>
    	
    </div>
</template>

<script>
    export default {
        name: 'Product_sswm',
        data: function () {
            return {
            }
        },
        mounted: function () {

        },
        created: function () {

        },
        methods: {

        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/product_12_zsw.vue